import { Box } from '@ltvco/refresh-lib/theme';
import { Control, Controller } from '@ltvco/refresh-lib/vendors';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React from 'react';

import {
  StyledSearchTypeSelect,
  StyledSearchTypeSelectContainer,
} from './components';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectInputProps {
  options: SelectOption[];
  value: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: string) => void;
  name: string;
  control: Control<any>;
  defaultOptionValue?: string;
  disabled?: boolean;
}

export const SelectInput = React.memo(
  ({
    options,
    onChange,
    name,
    control,
    defaultOptionValue,
    disabled,
  }: SelectInputProps) => {
    return (
      <Box sx={{ minWidth: '100%', height: 'auto' }}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <StyledSearchTypeSelectContainer>
              <StyledSearchTypeSelect
                {...field}
                id={`select-${name}`}
                value={field.value || defaultOptionValue}
                onChange={(e) => {
                  const selectedValue = e.target.value as string;
                  field.onChange(selectedValue);
                  onChange(selectedValue);
                }}
                IconComponent={KeyboardArrowDownIcon}
                options={options.map((option) => ({
                  value: option.value,
                  display: option.label,
                }))}
                disabled={disabled}
              ></StyledSearchTypeSelect>
            </StyledSearchTypeSelectContainer>
          )}
        />
      </Box>
    );
  }
);
